import { createStore } from 'redux';


export function saveToLocalStorage(state) {
    try {
        // Strip transient schedule filters so they do not survive a hard refresh.
        // classFilter / subFilter are session-only (e.g. set when navigating from Courses → Schedule).
        const stateToSave = {
            ...state,
            schedule: state.schedule ? {
                ...state.schedule,
                classFilter: [],
                subFilter: [],
                teacherFilter: '',
            } : state.schedule,
        };
        const serializedState = JSON.stringify(stateToSave);
        localStorage.setItem('session', serializedState)

    } catch (e) {
        console.log(e);
    }
}

export function loadFromLocalStorage(state) {
    try {
        const serializedState = localStorage.getItem('session')
        if (serializedState === null) return undefined;
        return JSON.parse(serializedState);
        localStorage.setItem('session', serializedState);
    } catch (e) {
        console.log(e);
        return undefined
    }
}
